import {Component} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import FileSaver from "file-saver";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs";

@Component({
    selector: "fhm-venue-signup-report-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-signup-page.component.html",
    standalone: false
})
export class VenueSignupReportPageComponent {


    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private router: Router) {

    }

    done(): void {
        this.router.navigate(["/main/customer-instance-venue-search"]);
    }


    downloadReport(): void {
        this.spinnersService.open();
        this.http.get("/fonzie/reportDownload/VenueSignupReport", {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "blob"
        })
            .pipe(catchError((error) => {
                return this.errorHandler.handleError(error);
            }))
            .subscribe((data) => {
                this.spinnersService.close();
                FileSaver.saveAs(data, "venues.csv");
            });
    }

}
